import { FSMNamedState, ObservableFiniteStateMachine, OMQuery } from "@apptivity-lab/firmament-node-sdk"

import { AffLesson } from "@firmament-packages/aff"

declare namespace AffLessonListStateMachine {
    export interface Start extends FSMNamedState {
        name: "start"
    }

    export interface Loading extends FSMNamedState {
        name: "loading"
        lessons: AffLesson[]
        query: OMQuery<AffLesson>
    }

    export interface Presenting extends FSMNamedState {
        name: "presenting"
        lessons: AffLesson[]
        query: OMQuery<AffLesson>
    }

    export interface ShowingError extends FSMNamedState {
        name: "showingError"
        error: Error
        lessons: AffLesson[]
        query: OMQuery<AffLesson>
    }

    export type State = Start |
        Loading |
        Presenting |
        ShowingError

    export type ListQueryConfiguration = {
        categories: string[]
        providers: string[],
        limit?: number
    }
}

export class AffLessonListStateMachine extends ObservableFiniteStateMachine<AffLessonListStateMachine.State> {
    constructor() {
        super({ name: "start" })
    }

    async refresh({ categories, providers, limit }: AffLessonListStateMachine.ListQueryConfiguration) {
        let existingLessons: AffLesson[]

        switch (this.state.name) {
            case "start":
                existingLessons = []
                break
            case "presenting":
                existingLessons = this.state.lessons
                break
            default:
                return
        }

        try {
            const query = AffLesson.query()
                .include("video")
                .include("coverPhoto")
                .include("provider")
                .include("provider.photo" as any)
                .include("categories")
                .sort("createdAt", "ASC")
                .limit(limit || 20)

            if (categories.length > 0) {
                query.filter("categorySet", "contains", categories as any)
            }
            if (providers.length > 0) {
                query.filterGroup(
                    providers.map((providerId) => ["provider", "equals", providerId as any]),
                    "OR"
                )
            }

            this.state = { name: "loading", lessons: existingLessons, query }

            await query.execute()
            this.success(query)
        } catch (error: unknown) {
            if (error instanceof Error) {
                this.fail(error)
            }
        }
    }

    private success(query: OMQuery<AffLesson>) {
        switch (this.state.name) {
            case "loading":
                this.state = { name: "presenting", lessons: query.resultObjects, query }
                break
            default:
                return
        }
    }

    private fail(error: Error) {
        switch (this.state.name) {
            case "loading":
                this.state = { name: "showingError", error, lessons: this.state.lessons, query: this.state.query }
                break
            default:
                return
        }
    }
}
